import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ParticleBackgroundComponent } from '../../lib/components/general/particle-background/particle-background.component';

@Component({
	selector: 'app-not-found',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, ParticleBackgroundComponent],
	templateUrl: './not-found-page.html',
	styleUrl: './not-found-page.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPage {
	private readonly location = inject(Location);

	goBack(): void {
		this.location.back();
	}
}
